import { useState } from "react";
import { faqs } from "@/mocks/narutoData";
import SectionHeading from "./SectionHeading";

export default function FaqSection() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-background-100/60 py-16 md:py-24">
      <div className="mx-auto max-w-[860px] px-4 md:px-6">
        <SectionHeading
          eyebrow="常见问题"
          title="关于同人导航，你想知道的都在这里"
          desc="整理了读者最常问的几类问题，帮助你更快了解本站的使用方式与收录规则。"
        />

        <div className="flex flex-col gap-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={f.q}
                className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
              >
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  aria-expanded={isOpen}
                >
                  <span className="font-heading text-sm md:text-base font-bold text-foreground-950">
                    {f.q}
                  </span>
                  <i
                    className={`ri-add-line text-xl text-primary-500 transition-transform duration-300 ${
                      isOpen ? "rotate-45" : ""
                    }`}
                  />
                </button>
                <div
                  className={`grid transition-all duration-300 ${
                    isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">{f.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}